// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import App from './App'
import router from './router'
import VueScrollTo from 'vue-scrollto'
import moment from 'moment'
import { store } from './services/store'

Vue.use(VueResource);
Vue.use(VueScrollTo);
Vue.use(Vuex);

moment.locale('fr');
Vue.filter('formatDate', function(value) {
  if (value) { 
    return moment(String(value)).format('LL')
  }
})
Vue.filter('formatHour', function(value) {
  if (value) { 
    return moment(String(value)).format('LT')
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js